export default [
    {
        // name: "guest",
        path: "/login",
        component: () => import("../components/layouts/Guest.vue"),
        meta: {
            middleware: "guest",
        },
        children: [
            {
                path: "",
                name: "login",
                component: () =>
                    import(/*webpackChunkName: "home"*/ "../pages/auth/LoginView.vue"),
                meta: {
                    title: "Log In",
                },
            },
            {
                path: "/reset-password",
                name: "reset-password",
                component: () =>
                    import(
                        /*webpackChunkName: "home"*/ "../pages/auth/ResetPasswordView.vue"
                    ),
                meta: {
                    title: "Reset Password",
                },
            },
            {
                path: "/pagenotfound",
                name: "pagesnotfound",
                component: () => import("../components/common/404NotFound.vue"),
            },
        ],
    },
];
